<template>
  <div class="app">

    <div v-show="!$route.meta.hideHeader">
      <Header />
    </div>
    
    <div :style="{'min-height':(screenHeight-80-70)+'px'}">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    
    <div v-show="!$route.meta.hideFooter">
      <Footer />
    </div>

  </div>
  
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: { Header,Footer },
  data() {
    return {
      screenHeight:0
    };
  },
  mounted(){
    this.screenHeight = window.innerHeight
    window.onresize = () => {
      return (() => {
        this.screenHeight = window.innerHeight
      })()
    }
    console.log(this.screenHeight)
  }
};
</script>

<style scoped>
.app{
  min-width:1300px;
}
</style>

